import type { PaneWidthController } from "./pane-width.js";

export function setPropsPaneCollapsed(
  collapsed: boolean,
  propsPane: HTMLElement | null,
  propsPaneToggle: HTMLButtonElement | null,
  componentWorkspace: HTMLElement | null,
  propsPaneSize: PaneWidthController,
): void {
  if (!propsPane || !propsPaneToggle) return;
  propsPane.classList.toggle("is-collapsed", collapsed);
  componentWorkspace?.classList.toggle("is-props-hidden", collapsed);
  propsPaneSize.apply();
  propsPaneToggle.setAttribute("aria-expanded", String(!collapsed));
  propsPaneToggle.setAttribute(
    "aria-label",
    collapsed ? "Показать Свойства" : "Скрыть Свойства",
  );
}

export function setTreePaneCollapsed(
  collapsed: boolean,
  treePane: HTMLElement | null,
  treePaneToggle: HTMLButtonElement | null,
  componentWorkspace: HTMLElement | null,
  treePaneSize: PaneWidthController,
): void {
  if (!treePane || !treePaneToggle) return;
  treePane.classList.toggle("is-collapsed", collapsed);
  componentWorkspace?.classList.toggle("is-tree-hidden", collapsed);
  treePaneSize.apply();
  treePaneToggle.setAttribute("aria-expanded", String(!collapsed));
  treePaneToggle.setAttribute(
    "aria-label",
    collapsed ? "Показать Structure" : "Скрыть Structure",
  );
}

export function togglePane(
  button: HTMLButtonElement,
  componentWorkspace: HTMLElement | null,
  treePaneSize: PaneWidthController,
  propsPaneSize: PaneWidthController,
  editorPaneSize: PaneWidthController,
  setTreeCollapsed: (collapsed: boolean) => void,
  setPropsCollapsed: (collapsed: boolean) => void,
): void {
  const paneKind = button.dataset.pane;
  const pane = paneKind === "actions"
    ? button.closest(".log")
    : button.closest(".pane");
  if (!pane) return;
  const hidden = pane.classList.toggle("is-collapsed");
  if (paneKind === "tree") {
    setTreeCollapsed(hidden);
    return;
  }
  if (paneKind === "props") {
    setPropsCollapsed(hidden);
    return;
  }
  if (paneKind === "editor") {
    componentWorkspace?.classList.toggle("is-editor-hidden", hidden);
    editorPaneSize.apply();
  }
  const title = pane.querySelector(".pane__title")?.textContent || "Actions";
  button.setAttribute("aria-expanded", String(!hidden));
  button.setAttribute("aria-label", hidden ? `Показать ${title}` : `Скрыть ${title}`);
}
